import { useState, useEffect } from 'react'
import { collection, query, where, orderBy, getDocs } from 'firebase/firestore'
import { db } from '../lib/firebase'
import { useTranslation } from 'react-i18next'

export default function WhyChooseUs() {
  const { t, i18n } = useTranslation()
  const [features, setFeatures] = useState([])
  const [loading, setLoading] = useState(true)


  useEffect(() => {
    loadFeatures()
  }, [])

  const loadFeatures = async () => {
    try {
      const q = query(
        collection(db, 'whyChooseUsFeatures'),
        where('isActive', '==', true),
        orderBy('order', 'asc')
      )

      const snapshot = await getDocs(q)

      if (snapshot.empty) {
        setFeatures([])
      } else {
        const loadedFeatures = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        setFeatures(loadedFeatures)
      }
    } catch (error) {
      setFeatures([])
    } finally {
      setLoading(false)
    }
  }

  const getLocalizedContent = (feature, field) => {
    const lang = i18n.language
    if (lang === 'en' && feature[`${field}_en`]) {
      return feature[`${field}_en`]
    }
    return feature[`${field}_vi`] || feature[field]
  }

  if (loading) {
    return (
      <section className="why-choose-us">
        <div className="container">
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          </div>
        </div>
      </section>
    )
  }

  return (
    <section className="why-choose-us">
      <div className="container">
        <h2>🌟 {t('whyChooseUs.title', 'Why choose DelyTour?')}</h2>
        <p className="subtitle">{t('whyChooseUs.subtitle', 'we bring a best experience for your trip')}</p>

        {features.length > 0 ? (
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={feature.id || index} className="feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3>{getLocalizedContent(feature, 'title')}</h3>
                <p>{getLocalizedContent(feature, 'description')}</p>
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-state">
            <div className="empty-icon">⚙️</div>
            <h3>Đang cập nhật tính năng | feature is updating</h3>
            <p>Chúng tôi đang cập nhật các tính năng nổi bật. Vui lòng quay lại sau!</p>
          </div>
        )}
      </div>

      <style>{`
        .why-choose-us {
          padding: 80px 24px;
          background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
        }

        .why-choose-us h2 {
          text-align: center;
          font-size: 2.5rem;
          margin-bottom: 16px;
          color: #1f2937;
        }

        .subtitle {
          text-align: center;
          font-size: 1.2rem;
          color: #6b7280;
          margin-bottom: 48px;
        }

        .features-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 32px;
        }

        .feature-card {
          background: white;
          padding: 32px;
          border-radius: 16px;
          text-align: center;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          transition: all 0.3s;
        }

        .feature-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
        }

        .feature-icon {
          font-size: 3.5rem;
          margin-bottom: 20px;
        }

        .feature-card h3 {
          font-size: 1.25rem;
          font-weight: 700;
          margin-bottom: 12px;
          color: #1f2937;
        }

        .feature-card p {
          color: #6b7280;
          line-height: 1.6;
        }

        .empty-state {
          text-align: center;
          padding: 60px 20px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 16px;
          backdrop-filter: blur(10px);
        }

        .empty-icon {
          font-size: 4rem;
          margin-bottom: 20px;
          opacity: 0.7;
        }

        .empty-state h3 {
          font-size: 1.5rem;
          margin-bottom: 12px;
          color: #1f2937;
        }

        .empty-state p {
          color: #6b7280;
          font-size: 1.1rem;
          line-height: 1.6;
        }

        @media (max-width: 768px) {
          .features-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </section>
  )
}

